import { SerializedStyles } from '@emotion/react';
import NextImage, { ImageProps } from 'next/image';

export default function Image({
  src,
  alt = '',
  width,
  height,
  fill,
  css,
  ...props
}: Partial<ImageProps> & { css?: SerializedStyles }) {
  if (!src) return null;

  let imageSrc = src;
  if (typeof src === 'string' && src.startsWith('//')) {
    imageSrc = `https:${src}`;
  }

  return (
    <NextImage
      src={imageSrc}
      alt={alt}
      width={width}
      height={height}
      fill={fill}
      css={css}
      {...props}
    />
  );
}
